import React, { useEffect, useState } from "react";
import downArrow from "../static/images/component_svg/downArrow.svg";
import styles from "./infogamespandigi.module.css";

function InfoGameSpandigi({ nums, renums }) {
  const [question, setQuestion] = useState();
  const [answer, setAnswer] = useState(false);

  const numshow = renums ? renums : nums;
  let index = 0;
  useEffect(function () {
    const intervalId = setInterval(() => {
      if (index < nums.length) {
        setQuestion(nums[index]);
        index++;
      } else {
        setQuestion("");
        setAnswer(true);
        clearInterval(intervalId);
      }
    }, 1000);
  }, []);

  return (
    <div className={styles.questionBox}>
      <div className={styles.questionText}>{question}</div>
      <img className={styles.arrow} src={downArrow} alt="downArrow"></img>
      <div className={styles.body}>
        {numshow.map((num) => (
          <div key={num} className={styles.num}>
            {answer ? <div>{num}</div> : null}
          </div>
        ))}
      </div>
    </div>
  );
}

export default InfoGameSpandigi;
